import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import Copy from 'Src/components/Copy';
import FontIcon from 'Src/components/icons/FontIcon';
import { Flex } from 'Src/components/layout/Flex';
import AuthRequestUIBlockerMessage from 'Src/feature/auth-request/AuthRequestUIBlockerMessage';
import { useCurrentAuthRequest } from 'Src/feature/auth-request/useCurrentAuthRequest';
import { Modal } from 'Src/feature/modal/Modal';
import { ModalAction } from 'Src/feature/modal/ModalAction';
import { ModalActions } from 'Src/feature/modal/ModalActions';
import { ModalContent } from 'Src/feature/modal/ModalContent';
import AuthorizationRequest from 'Src/models/AuthorizationRequest';

import { Field, Form, useAuthRequestUIBlocker } from './useAuthRequestUIBlocker';

import styles from './AuthRequestUIBlocker.module.scss';

const AuthRequestUIBlocker: FC = () => {
  const { t } = useTranslation();
  const { currentRequest } = useCurrentAuthRequest();
  const store = useAuthRequestUIBlocker();

  return (
    <Modal
      open={store.isOpen}
      variant="grow"
    >
      <ModalContent>
        <Flex className={styles['content_wrapper']}>
          <Copy variant="h6" value={t('approvalRequest.labels.managerApprovalNeeded')} />
          <AuthRequestUIBlockerMessage data={currentRequest as AuthorizationRequest} />
          {store.isCardReaderConnected && (
            <Flex horizontal justifyContent="center" alignItems="center">
              <FontIcon name="credit_card" />
              <Copy color="textSecondary" variant="body" value={store.form.state.errors.swipe ? t('payment.info.pleaseSwipeAgain') : t('payment.info.swipeCard')} />
            </Flex>
          )}
          <Form usedForm={store.form} className={styles['form']} omitChangeTracking>
            <Field
              type="pin"
              name="pin"
              fullWidth
              onAfterChange={() => {
                store.form.action.setValue('swipe', undefined, { shouldValidate: true, shouldTouch: true, shouldDirty: true });
              }}
            />
          </Form>
        </Flex>
      </ModalContent>
      <ModalActions>
        <ModalAction
          label={t('labels.cancel')}
          color="secondary"
          onClick={store.onCancel}
        />
        <ModalAction
          label={t('labels.approve')}
          color="primary"
          onClick={store.onSave}
          disabled={!store.form.state.isValid || !store.form.state.isDirty}
        />
      </ModalActions>
    </Modal>
  );
};

export { AuthRequestUIBlocker };
